






























import { defineComponent } from '@nuxtjs/composition-api';

interface Action extends BlokFieldLink {
  style: 'link' | 'button' | 'button-large';
}

interface Props extends Blok {
  title: string;
  titleSuperscript: string;
  text: string;
  link: Action[];
  titleSize: number;
  titleFontSize: string;
  textFontSize: string;
  textSize: number;
  marginTop: number;
  paddingTop: number;
  paddingBottom: number;
  bottomContent: Blok[];
  imageFullWidth: boolean;
  backgroundImage: BlokFieldAsset;
  horizontalAlignment: 'flex-start' | 'center' | 'flex-end';
}

export default defineComponent({
  props: {
    blok: { type: Object as () => Props, required: true },
  },
  computed: {
    getText(): string {
      return ((typeof this.blok.text) === "string" ? this.blok.text : '').replaceAll('\n', '<br />')
    },
    style(): CSSVars {
      return {
        paddingTop: this.blok.paddingTop
          ? `${this.blok.paddingTop}rem`
          : '8rem',
        paddingBottom: this.blok.paddingBottom
          ? `${this.blok.paddingBottom}rem`
          : '8rem',

        textAlign: this.blok.horizontalAlignment || 'center',
        justifyItems: this.blok.horizontalAlignment || 'center',

        '--image-width': this.blok.imageFullWidth ? '100vw' : '100%',
        '--margin-top': `${this.blok.marginTop || 0}rem`,

        '--title-font-size': this.blok.titleFontSize || '4.25rem',
        '--text-font-size': this.blok.textFontSize || '1rem',

        '--title-max-width': this.blok.titleSize
          ? `${this.blok.titleSize}ch`
          : '100%',
        '--text-max-width': this.blok.textSize
          ? `${this.blok.textSize}ch`
          : '100%',
      };
    },
    action(): Action | undefined {
      return this.blok.link[0];
    },
    hasBottomContent(): boolean {
      return 'bottomContent' in this.blok && this.blok.bottomContent.length > 0;
    },
  },
});
